function updateHeaderHeightVar() {
  const header = document.querySelector('#shopify-section-header');
  if (header) {
    const height = header.offsetHeight + 'px';
    document.documentElement.style.setProperty('--header-height', height);
  }
}

window.addEventListener('load', updateHeaderHeightVar);
window.addEventListener('resize', updateHeaderHeightVar);

//商品詳細アコーディオン

document.querySelectorAll('.cart_accordion').forEach((el) => {
  const content = el.querySelector('.content');

  el.addEventListener('toggle', () => {
    if (el.open) {
      const height = content.scrollHeight;
      content.style.maxHeight = height + 'px';
      content.style.padding = '10px';
      content.addEventListener('transitionend', function removeMaxHeight() {
        content.style.maxHeight = 'none';
        content.removeEventListener('transitionend', removeMaxHeight);
      });
    } else {
      const height = content.scrollHeight;
      content.style.maxHeight = height + 'px';

      requestAnimationFrame(() => {
        content.style.maxHeight = 0;
        content.style.padding = '0 10px';
      });
    }
  });
});

// smooth scroll

  document.addEventListener("DOMContentLoaded", function () {
    const headerHeight = document.querySelector('#shopify-section-header')?.offsetHeight || 0;

    if (window.location.hash) {
      const targetId = window.location.hash.substring(1);
      const targetElement = document.getElementById(targetId);

      if (targetElement) {
        setTimeout(() => {
          const top = targetElement.getBoundingClientRect().top + window.pageYOffset - headerHeight;

          window.scrollTo({
            top: top,
            behavior: "smooth"
          });
        }, 100);
      }
    }
  });

// cart validation

document.addEventListener('DOMContentLoaded', function () {
  const form = document.getElementById('cart');
  const propertyName = document.getElementById('property-name');
  const constructionDate = document.getElementById('construction-date');
  const checkboxes = document.querySelectorAll('.multi-select');

  const hiddenName = document.getElementById('hidden-property-name');
  const hiddenDate = document.getElementById('hidden-construction-date');
  const hiddenOptions = document.getElementById('hidden-options');

  form.addEventListener('submit', function (e) {
    let isValid = true;
    if (!propertyName.value.trim()) {
      document.getElementById('error-property-name').style.display = 'block';
      isValid = false;
    } else {
      document.getElementById('error-property-name').style.display = 'none';
      hiddenName.value = propertyName.value.trim();
    }

    if (!constructionDate.value.trim()) {
      document.getElementById('error-construction-date').style.display = 'block';
      isValid = false;
    } else {
      document.getElementById('error-construction-date').style.display = 'none';
      hiddenDate.value = constructionDate.value.trim();
    }

    const selected = Array.from(checkboxes).filter(cb => cb.checked);
    if (selected.length === 0) {
      document.getElementById('error-checkbox').style.display = 'block';
      isValid = false;
    } else {
      document.getElementById('error-checkbox').style.display = 'none';
      hiddenOptions.value = selected.map(cb => cb.value).join(', ');
    }
    if (!isValid) {
      e.preventDefault();
    }
  });
});